/* eslint-disable */ import { memoEval, violationsComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const tuscanSinglePlatformBaseComponents = [
    attachComponent.withComponent(violationsComponent, 'default', true).withEntity('TuscanSinglePlatformBase').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.$violations
        ], ($violations)=>({
            violations: $violations
        })))
];

//# sourceMappingURL=tuscan-single-platform-base.js.map